import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui/ui-component/Loadable';

// login routing
const AuthLogin = Loadable(lazy(() => import('pages/authentication/authentication/Login')));
const AuthRegister = Loadable(lazy(() => import('pages/authentication/authentication/Register')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/',
    element: (
        <NavMotion>
            <GuestGuard>
                <MinimalLayout />
            </GuestGuard>
        </NavMotion>
    ),
    children: [
        {
            path: '/login',
            element: <AuthLogin />
        },
        {
            path: '/sign-up',
            element: <AuthRegister />
        }
    ]
};

export default LoginRoutes;
